module.exports = __webpack_public_path__ + "static/media/loader.e73e38fb.svg";